import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'

import { Page } from '../../common/components/sections'
import { APP_ROUTES } from '../../common/constants'

import {
  EmailLoginPage,
  LoginPage,
  LogoutPage,
  UserSettingsPage,
} from './pages'
import { AuthRedirect, GuestRedirect } from './sections'

const AccountRouter = () => (
  <>
    <Routes>
      <Route
        path={APP_ROUTES.ACCOUNT.children.LOGIN.path}
        element={
          <GuestRedirect>
            <LoginPage />
          </GuestRedirect>
        }
      />
      <Route
        path={APP_ROUTES.ACCOUNT.children.LOGIN_EMAIL.path}
        element={
          <GuestRedirect>
            <EmailLoginPage />
          </GuestRedirect>
        }
      />
      <Route
        element={
          <Page>
            <Outlet />
          </Page>
        }
      >
        <Route
          path={APP_ROUTES.ACCOUNT.children.SETTINGS.path}
          element={
            <AuthRedirect>
              <UserSettingsPage />
            </AuthRedirect>
          }
        />
      </Route>
      <Route
        path={APP_ROUTES.ACCOUNT.children.LOGOUT.path}
        element={
          <AuthRedirect>
            <LogoutPage />
          </AuthRedirect>
        }
      />
    </Routes>
    <Outlet />
  </>
)

export default AccountRouter
